import {Toggle} from '@/components/atoms'

const ToggleButtonControl = props => {
  /**
   * @typedef {Object} Props
   * @property {function} handleChange - Function to handle change events.
   * @property {Object} data - Data object.
   * @property {string} path - Path string.
   * @property {Object} errors - Errors object.
   * @property {Object} schema - Schema object.
   * @property {Object} uischema - UI schema object.
   * @property {boolean} required - Indicates if the field is required.
   * @property {boolean} enabled - Indicates if the field is enabled.
   */
  const {handleChange, data, path, errors, schema, uischema, required, enabled} = props

  return (
    <Toggle
      value={data}
      updateValue={newVal => handleChange(path, newVal)}
      errors={errors}
      schema={schema}
      uiSchema={uischema}
      required={required}
      disabled={!enabled}
    />
  )
}

export default ToggleButtonControl
